export default __webpack_public_path__ + "static/media/move_ITEM_to_DESTINATION.92078903.svg";